'use client'

import React from 'react'
import Image from 'next/image'
import AnimatedSection from '@/components/AnimatedSection'
import styles from './styles.module.css'

const ApplicationOverview: React.FC = () => {
	return (
		<section className={styles.applicationOverview}>
			<div className={styles.container}>
				<div className={styles.content}>
					<AnimatedSection animation='slideUp'>
						<div className={styles.subtitle}>Обзор приложения</div>
						<h2
							className={styles.title}
							dangerouslySetInnerHTML={{
								__html: '<span>True.pay B2B — это платёжный модуль</span> между юрлицами'
							}}
						/>
					</AnimatedSection>

					<AnimatedSection animation='slideUp'>
						<div className={styles.description}>
							<p className={styles.paragraph}>
							Обычный платёж по счёту между компаниями — это долгий процесс согласований, ручного контроля реквизитов и межбанковских проверок. <span>Приложение True.pay B2B превращает этот процесс в быструю онлайн-сделку.</span></p>
							<p className={styles.paragraph}>
							Мы объединили модули моментальных расчётов Сбера, СБП и кредитование юрлиц в одном решении. Когда покупатель переходит по ссылке, он видит заполненную форму платежа. <span>Больше никакого ручного копирования</span> ИНН, БИК и расчётных счётов.
						</p>
						</div>
					</AnimatedSection>
				</div>

				<AnimatedSection animation='slideUp'>
					<div className={styles.imageContainer}>
						<Image
							src='/images/b2b/applictaion_desktop.png'
							alt='Обзор приложения True.pay B2C'
							width={1110}
							height={600}
							className={styles.desktopImage}
							unoptimized
						/>
						<Image
							src='/images/b2b/applictaion_tablet.png'
							alt='Обзор приложения True.pay B2C'
							width={680}
							height={368}
							className={styles.tabletImage}
							unoptimized
						/>
						<Image
							src='/images/b2b/applictaion_mobile.png'
							alt='Обзор приложения True.pay B2C'
							width={328}
							height={294}
							className={styles.mobileImage}
							unoptimized
						/>
					</div>
				</AnimatedSection>
			</div>
		</section>
	)
}

ApplicationOverview.displayName = 'ApplicationOverview'

export default ApplicationOverview
